import { Link } from "react-router-dom";
import { clinicInfo } from "../../mocks/home-data";

const footerLinks = {
  hizmetler: [
    { label: "Pet Hekimliği", path: "/hizmetler" },
    { label: "Kuş Bakımı", path: "/kus-egzotik" },
    { label: "Egzotik Hayvanlar", path: "/kus-egzotik" },
    { label: "Ağız & Diş Cerrahisi", path: "/hizmetler" },
    { label: "Laboratuvar", path: "/hizmetler" },
  ],
  turler: [
    { label: "Papağan Türleri", path: "/kus-egzotik" },
    { label: "Sürüngenler", path: "/kus-egzotik" },
    { label: "Kemirgenler", path: "/kus-egzotik" },
    { label: "Kanarya & Muhabbet", path: "/kus-egzotik" },
  ],
  klinik: [
    { label: "Hakkımızda", path: "/hakkimizda" },
    { label: "Ekibimiz", path: "/hakkimizda" },
    { label: "Randevu Al", path: "/iletisim" },
    { label: "Çalışma Saatleri", path: "/iletisim" },
  ],
};

const quickStats = [
  { num: "2020", label: "Kuruluş Yılı", icon: "ri-award-line" },
  { num: "50+", label: "Egzotik Tür", icon: "ri-bug-line" },
  { num: "5000+", label: "Mutlu Hasta", icon: "ri-heart-line" },
];

export default function Footer() {
  return (
    <footer className="bg-[#f5f3ef]">

      {/* Top CTA Strip */}
      <div className="bg-primary-700">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-12 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <p className="text-primary-200 text-xs font-semibold mb-2 uppercase tracking-widest">Ankara Keçiören</p>
            <h3 className="text-white text-2xl md:text-3xl font-bold leading-tight">
              Dostunuz için en iyi bakım<br />
              <span className="text-primary-200">burada başlıyor.</span>
            </h3>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href={`tel:${clinicInfo.phoneRaw}`}
              className="inline-flex items-center gap-2 px-6 py-3 bg-white text-primary-800 font-semibold rounded-xl hover:bg-primary-50 transition-all duration-300 whitespace-nowrap text-sm cursor-pointer"
            >
              <i className="ri-phone-line w-4 h-4 flex items-center justify-center" />
              {clinicInfo.phone}
            </a>
            <Link
              to="/iletisim"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-400 text-white font-semibold rounded-xl transition-all duration-300 whitespace-nowrap text-sm"
            >
              <i className="ri-calendar-line w-4 h-4 flex items-center justify-center" />
              Randevu Al
            </Link>
          </div>
        </div>
      </div>

      {/* Stats Row */}
      <div className="bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-8 md:gap-14">
              {quickStats.map((s) => (
                <div key={s.label} className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-primary-50 flex items-center justify-center">
                    <i className={`${s.icon} text-primary-600 w-5 h-5 flex items-center justify-center`} />
                  </div>
                  <div>
                    <p className="text-xl font-bold text-gray-900 leading-none">{s.num}</p>
                    <p className="text-xs text-gray-400 mt-0.5">{s.label}</p>
                  </div>
                </div>
              ))}
            </div>
            {/* Instagram quick links */}
            <div className="flex items-center gap-3">
              <a
                href={`https://instagram.com/${clinicInfo.instagram1}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-pink-500 to-orange-400 text-white text-xs font-semibold hover:opacity-90 transition-opacity whitespace-nowrap cursor-pointer"
              >
                <i className="ri-instagram-line w-4 h-4 flex items-center justify-center" />
                @ihsan_ozer_veteriner_klinigi
              </a>
              <a
                href={`https://instagram.com/${clinicInfo.instagram2}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-pink-500 to-orange-400 text-white text-xs font-semibold hover:opacity-90 transition-opacity whitespace-nowrap cursor-pointer"
              >
                <i className="ri-instagram-line w-4 h-4 flex items-center justify-center" />
                @ankarakusveterineri
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-12">

          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <img
                src="/assets/images/brand-logo.jpg"
                alt="İhsan Özer Veteriner Kliniği"
                className="h-14 w-14 rounded-2xl object-cover ring-2 ring-primary-200"
              />
              <div>
                <p className="text-lg font-bold text-gray-900 leading-tight">İhsan Özer</p>
                <p className="text-sm text-primary-600 leading-tight font-medium">Veteriner Kliniği</p>
              </div>
            </div>

            <p className="text-gray-500 text-sm leading-relaxed mb-7 max-w-sm">
              Ankara Keçiören'de kuş ve egzotik hayvan bakımı ile hizmet veren modern veteriner kliniği. Tüylü ve pullu dostlarınızın sağlığı için özenle çalışıyoruz.
            </p>

            {/* Contact Info */}
            <div className="space-y-3 mb-7">
              <a
                href={`tel:${clinicInfo.phoneRaw}`}
                className="flex items-center gap-3 text-sm text-gray-600 hover:text-primary-600 transition-colors cursor-pointer group"
              >
                <div className="w-9 h-9 rounded-xl bg-primary-50 group-hover:bg-primary-100 flex items-center justify-center transition-colors">
                  <i className="ri-phone-line w-4 h-4 flex items-center justify-center text-primary-500" />
                </div>
                <span className="font-medium">{clinicInfo.phone}</span>
              </a>
              <div className="flex items-start gap-3 text-sm text-gray-500">
                <div className="w-9 h-9 rounded-xl bg-primary-50 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center text-primary-500" />
                </div>
                <span className="leading-relaxed">{clinicInfo.address}</span>
              </div>
              <div className="flex items-start gap-3 text-sm text-gray-500">
                <div className="w-9 h-9 rounded-xl bg-primary-50 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-time-line w-4 h-4 flex items-center justify-center text-primary-500" />
                </div>
                <div>
                  <p className="text-gray-600 font-medium">{clinicInfo.workingHours}</p>
                  <p className="text-gray-400 text-xs mt-0.5">{clinicInfo.sunday}</p>
                </div>
              </div>
            </div>

            {/* Social Icons */}
            <div className="flex items-center gap-2">
              <a
                href={`https://instagram.com/${clinicInfo.instagram1}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-xl bg-gradient-to-br from-pink-500 via-rose-500 to-orange-400 flex items-center justify-center hover:scale-105 transition-transform cursor-pointer"
                title={`@${clinicInfo.instagram1}`}
              >
                <i className="ri-instagram-line w-5 h-5 flex items-center justify-center text-white" />
              </a>
              <a
                href={`https://instagram.com/${clinicInfo.instagram2}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-xl bg-gradient-to-br from-pink-500 via-rose-500 to-orange-400 flex items-center justify-center hover:scale-105 transition-transform cursor-pointer"
                title={`@${clinicInfo.instagram2}`}
              >
                <i className="ri-instagram-line w-5 h-5 flex items-center justify-center text-white" />
              </a>
              <a
                href="https://wa.me/905396960677"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-xl bg-green-500 flex items-center justify-center hover:scale-105 transition-transform cursor-pointer"
                title="WhatsApp"
              >
                <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center text-white" />
              </a>
              <a
                href={`tel:${clinicInfo.phoneRaw}`}
                className="w-10 h-10 rounded-xl bg-primary-500 flex items-center justify-center hover:scale-105 transition-transform cursor-pointer"
                title="Telefon"
              >
                <i className="ri-phone-line w-5 h-5 flex items-center justify-center text-white" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-bold text-gray-900 text-sm mb-5 flex items-center gap-2">
              <span className="w-1 h-4 rounded-full bg-primary-400 inline-block" />
              Hizmetler
            </h4>
            <ul className="space-y-3">
              {footerLinks.hizmetler.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-gray-500 hover:text-primary-600 transition-colors flex items-center gap-2 group"
                  >
                    <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-gray-300 group-hover:text-primary-400 transition-colors" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-gray-900 text-sm mb-5 flex items-center gap-2">
              <span className="w-1 h-4 rounded-full bg-primary-400 inline-block" />
              Türler
            </h4>
            <ul className="space-y-3">
              {footerLinks.turler.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-gray-500 hover:text-primary-600 transition-colors flex items-center gap-2 group"
                  >
                    <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-gray-300 group-hover:text-primary-400 transition-colors" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-gray-900 text-sm mb-5 flex items-center gap-2">
              <span className="w-1 h-4 rounded-full bg-primary-400 inline-block" />
              Klinik
            </h4>
            <ul className="space-y-3">
              {footerLinks.klinik.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-gray-500 hover:text-primary-600 transition-colors flex items-center gap-2 group"
                  >
                    <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-gray-300 group-hover:text-primary-400 transition-colors" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>

            {/* WhatsApp CTA */}
            <div className="mt-8 p-4 bg-green-50 rounded-2xl border border-green-100">
              <p className="text-xs text-green-700 font-semibold mb-1">WhatsApp ile ulaşın</p>
              <p className="text-xs text-green-600 mb-3">Hızlı cevap, kolay randevu</p>
              <a
                href="https://wa.me/905396960677"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2 bg-green-500 hover:bg-green-600 text-white text-xs font-semibold rounded-xl transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center" />
                Mesaj Gönder
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-5">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <p className="text-xs text-gray-400">
              © {new Date().getFullYear()} İhsan Özer Veteriner Kliniği · Ankara Keçiören. Tüm hakları saklıdır.
            </p>
            <div className="flex items-center gap-5 text-xs text-gray-400">
              <Link to="/" className="hover:text-primary-600 transition-colors">Gizlilik Politikası</Link>
              <Link to="/" className="hover:text-primary-600 transition-colors">Kullanım Koşulları</Link>
              <span className="flex items-center gap-1">
                <i className="ri-map-pin-2-line w-3 h-3 flex items-center justify-center text-primary-400" />
                Keçiören, Ankara
              </span>
            </div>
          </div>
        </div>
      </div>

    </footer>
  );
}
